import { render, staticRenderFns } from "./ShoppingsComponent.vue?vue&type=template&id=873ec31a&scoped=true&"
import script from "./ShoppingsComponent.vue?vue&type=script&lang=js&"
export * from "./ShoppingsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873ec31a",
  null
  
)

export default component.exports